/**
 * CopyableMember - Wrapper component for member ID values
 *
 * Pre-configured CopyableValue for displaying member IDs with member preview tooltip.
 * Shows an empty state badge when no member ID is provided.
 *
 * @example
 * ```tsx
 * <CopyableMember
 *   memberId="user123"
 *   fullName="John Doe"
 *   email="john@example.com"
 * />
 * ```
 */

import React from 'react';
import { CopyableValue } from './CopyableValue';
import { EmptyStateBadge } from './styles';
import type { CopyableMemberProps } from './types';

export const CopyableMember: React.FC<CopyableMemberProps> = ({
  memberId,
  fullName,
  email,
  avatarUrl,
  onCopy,
  className,
}) => {
  // If no member ID, show empty state
  if (!memberId) {
    return <EmptyStateBadge className={className}>—</EmptyStateBadge>;
  }

  return (
    <CopyableValue
      value={memberId}
      variant="member"
      label="member"
      memberData={{
        fullName,
        email,
        avatarUrl,
      }}
      onCopy={onCopy}
      className={className}
    />
  );
};

export default CopyableMember;
